import { render, staticRenderFns } from "./Approvement.vue?vue&type=template&id=72146209&scoped=true"
import script from "./Approvement.vue?vue&type=script&lang=js"
export * from "./Approvement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72146209",
  null
  
)

export default component.exports